/*!
 *
 *	pagetop.js
 *
 */

var pagetop = {
	init: function(options){

		this.settings = {
			offsetY: 100,
			activeClass: 'active',
			pagetopId: '#page2top'
		};
		var opt = options || {};
		var flg = true;
		var isActive = false;
		this.settings = $.extend( this.settings, opt );
		this.$btn = $(this.settings.pagetopId);
		var self = this;


		origin.$window.on('scroll', function() {
			if (flg) {
				var _scrollTop = origin.$window.scrollTop();
				if (_scrollTop > self.settings.offsetY) {
					self.$btn.addClass(self.settings.activeClass);
					isActive = true;
				} else {
					self.$btn.removeClass(self.settings.activeClass);
					isActive = false;

				}

			}
		});
	}
};

module.exports = pagetop;



//////////////////
// WEBPACK FOOTER
// ./dev/js/components/module/pagetop.js
// module id = 11
// module chunks = 0